/* Progressive enhancement. All answers and destination links are rendered by Liquid. */
(() => {
  document.querySelectorAll('[data-lxk-root]').forEach(root => {
    const index = Array.from(root.querySelectorAll('[data-lxk-index-item]'));
    const form = root.querySelector('[data-lxk-search]');
    const output = root.querySelector('[data-lxk-results]');
    if (!form || !output) return;
    const normalise = value => value.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    form.addEventListener('submit', event => {
      event.preventDefault();
      const terms = normalise(form.querySelector('input').value.trim()).split(/\s+/).filter(Boolean);
      output.replaceChildren();
      if (!terms.length) return;
      const matches = index.filter(item => terms.every(term => normalise(item.textContent).includes(term)));
      const heading = document.createElement('h2');
      heading.textContent = `${matches.length} matching ${matches.length === 1 ? 'answer' : 'answers'}`;
      output.append(heading);
      matches.forEach(item => {
        const source = item.querySelector('a');
        if (!source) return;
        const link = document.createElement('a');
        link.href = source.href;
        link.className = 'lxk-result';
        link.textContent = source.textContent;
        output.append(link);
      });
      if (!matches.length) {
        const message = document.createElement('p');
        message.textContent = 'Try a shorter phrase or browse the topics below.';
        output.append(message);
      }
      output.scrollIntoView({block:'start'});
    });
  });
})();
